// src/components/TestimonialsCarousel.tsx
import { useEffect, useState } from 'react';
import { Star, User, Quote } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const testimonials = [
  {
    id: 1,
    name: "Ana Kovač",
    role: "Lastnica stanovanja",
    rating: 5,
    testimonial: "Izjemna kakovost keramičnih ploščic in profesionalna izvedba. Zelo sem zadovoljna z rezultatom in jih z veseljem priporočam vsem, ki iščejo kakovostne materiale za svoj dom.",
    location: "Ljubljana"
  },
  {
    id: 2,
    name: "Marko Novak",
    role: "Arhitekt",
    rating: 5,
    testimonial: "Kot arhitekt cenim njihovo široko izbiro materialov in strokovno svetovanje. Sodelovanje z njimi je vedno prijetno in rezultati so vedno odlični.",
    location: "Maribor"
  },
  {
    id: 3,
    name: "Maja Horvat",
    role: "Notranja oblikovalka",
    rating: 5,
    testimonial: "Njihov tehnični kamen je izjemne kakovosti. Stranke so vedno navdušene nad končnim izgledom. Zanesljiv partner za vse projekte.",
    location: "Celje"
  },
  {
    id: 4,
    name: "Janez Kralj",
    role: "Lastnik hiše",
    rating: 5,
    testimonial: "Odlična izkušnja od začetka do konca. Strokovno svetovanje, kakovostni materiali in hitra izvedba. Moja nova kuhinja je točno takšna, kot sem si jo zamislil.",
    location: "Kranj"
  },
  {
    id: 5,
    name: "Nina Zupan",
    role: "Lastnica apartmajev",
    rating: 5,
    testimonial: "Opremila sem tri apartmaje in pri vseh sem uporabila njihove storitve. Zanesljivost, kakovost in profesionalen odnos so razlogi, zakaj se vedno vrnem k njim.",
    location: "Portorož"
  },
  {
    id: 6,
    name: "Luka Vidmar",
    role: "Gradbeni inženir",
    rating: 5,
    testimonial: "Sodelovanje pri večjih projektih je vedno teklo gladko. Kakovost materialov in izvedbe je na najvišji ravni. Priporočam vsem, ki iščejo zanesljivega partnerja.",
    location: "Nova Gorica"
  },
  {
    id: 7,
    name: "Eva Košir",
    role: "Lastnica restavracije",
    rating: 5,
    testimonial: "Prenova naše restavracije je bila zaključena v dogovorjenem roku in v okviru proračuna. Keramika je odlične kakovosti in kljub visoki obremenitvi še vedno izgleda kot nova.",
    location: "Koper"
  },
  {
    id: 8,
    name: "Peter Žagar",
    role: "Investitor",
    rating: 5,
    testimonial: "Pri opremljanju večstanovanjske stavbe je bilo sodelovanje z njimi zelo profesionalno. Kakovost materialov in storitev je presegla moja pričakovanja.",
    location: "Velenje"
  },
  {
    id: 9,
    name: "Mateja Kos",
    role: "Lastnica salona",
    rating: 5,
    testimonial: "Estetsko dovršeni materiali in profesionalna izvedba. Moj salon je požel veliko pohval ravno zaradi izbranega kamna in keramike. Zelo priporočam!",
    location: "Murska Sobota"
  },
];

const TestimonialsCarousel = () => {
  const [autoplay, setAutoplay] = useState(true);
  const [, setCurrentSlide] = useState(0);
  
  const itemsPerView = 3;
  const totalSlides = Math.ceil(testimonials.length / itemsPerView);
  
  useEffect(() => {
    if (!autoplay) return;
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [autoplay, totalSlides]);
  
  return (
    <div className="mt-10">
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        className="w-full"
        onMouseEnter={() => setAutoplay(false)}
        onMouseLeave={() => setAutoplay(true)}
      >
        <CarouselContent>
          {testimonials.map((testimonial) => (
            <CarouselItem key={testimonial.id} className="md:basis-1/3 lg:basis-1/3">
              <div
                className="h-full bg-white rounded-lg p-6 shadow-md border border-stone-100 transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.3)] hover:border-secondary"
              >
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center text-secondary">
                      <User size={18} />
                    </div>
                    <div>
                      <h3 className="text-stone-800 font-semibold">{testimonial.name}</h3>
                      <p className="text-sm text-stone-500">{testimonial.role}, {testimonial.location}</p>
                    </div>
                  </div>
                  <div className="text-amber-400 flex">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <Star key={i} size={16} fill="currentColor" />
                    ))}
                  </div>
                </div>
                
                <div className="flex-grow">
                  <Quote size={20} className="text-secondary/30 mb-2" />
                  <p className="text-stone-600 italic">{testimonial.testimonial}</p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="flex justify-center mt-8 space-x-2">
          <CarouselPrevious className="static translate-y-0 bg-white border-secondary text-secondary hover:bg-secondary hover:text-white" />
          <CarouselNext className="static translate-y-0 bg-white border-secondary text-secondary hover:bg-secondary hover:text-white" />
        </div>
      </Carousel>
    </div>
  );
};

export default TestimonialsCarousel;